import tinycolor from "tinycolor2";
import { ColorComponentContainer } from "../ColorComponentContainer";
import { useColorComponent } from "../useColorComponent";
import { ColorComponentType } from "store/features/colorPicker/types";

export const HSV = ({ hex }: { hex: string }) => {
    const { color, components, handleChange } = useColorComponent(tinycolor(hex).toHsv(), "hsv");
    return (
        <>
            {(Object.keys(components) as Array<keyof typeof components>).map((key) => {
                const component = components[key];
                return (
                    <ColorComponentContainer
                        componentKey={key}
                        type={component.type}
                        value={component.type === ColorComponentType.PERCENTAGE ? color[key] * 100 : color[key]}
                        max={component.max}
                        handleChange={handleChange}
                    />
                );
            })}
        </>
    );
};
